<template lang="pug">
  .b-history-block
    template(v-if="items.length <= 2")
      ._item(v-for="item in items" :key="item.id")
        UserAvatar._author(:user="item.author")
        ._date {{ getStringDate(item.createdAt) }}
        TaskChangeComponentSelector(:change="item")
    template(v-else-if="collapsed")
      ._item(:key="lastItem.id")
        UserAvatar._author(:user="lastItem.author")
        ._date {{ getStringDate(lastItem.createdAt) }}
        TaskChangeComponentSelector(:change="lastItem")
        Btn._btn(transparent grey xs narrow @click="collapsed = false") Еще {{ expandText }}
          Icon(name="expand")
    template(v-else)
      ._item(v-for="item in items.slice(0, items.length - 1)" :key="item.id")
        UserAvatar._author(:user="item.author")
        ._date {{ getStringDate(item.createdAt) }}
        TaskChangeComponentSelector(:change="item")
      ._item(:key="lastItem.id")
        UserAvatar._author(:user="lastItem.author")
        ._date {{ getStringDate(lastItem.createdAt) }}
        TaskChangeComponentSelector(:change="lastItem")
        Btn._btn(transparent grey xs narrow @click="collapsed = true") Свернуть
          Icon._collapse(name="expand")
</template>

<script>
import utils from '@/utils/common';

import UserAvatar from '@/components/UserAvatar.vue';
import TaskChangeComponentSelector from '@/components/task/change/TaskChangeComponentSelector.vue';

export default {
  name: 'TaskDetailHistoryBlock',
  components: { TaskChangeComponentSelector, UserAvatar },
  props: {
    items: Array,
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    lastItem() { return this.items[this.items.length - 1]; },
    expandText() { return utils.pluralWord(this.items.length - 1, 'изменение', 'изменения', 'изменений'); },
  },
  methods: {
    getStringDate(date) { return utils.convertDateToString(date, 'long', true); },
  },
};
</script>

<style scoped lang="scss">
.history-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 53px;

  &__item:hover &__author {
    opacity: 1;
  }

  &__author {
    width: 32px;
    height: 32px;
    border-radius: 12px;
    margin-right: 20px;
    opacity: 0;
    position: absolute;
    left: -49px;
  }

  &__date {
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.01em;
    color: var(--color-dark-gray);
    opacity: 0.5;
    width: 160px;
  }

  &__item {
    font-size: 14px;
    color: var(--color-dark-gray);
    display: flex;
    align-items: center;
    position: relative;
    min-height: 32px;
  }

  &__btn {
    margin-left: auto;
  }

  &__collapse {
    transform: rotate(180deg);
  }

  ::v-deep .old {
    //filter: grayscale(100%);
    position: relative;
    opacity: .5;

    &:after {
      content:'';
      position: absolute;
      top: 50%;
      left: -5px;
      right: -5px;
      height: 1px;
      background: #788CA1;
      display: block;
    }
  }

  @media (max-width: 1000px) {
    &__item {
      flex-wrap: wrap;
      row-gap: 5px;
    }

    &__btn {
      width: 100%;
      margin-top: 15px;
    }
  }

  @media (max-width: 900px) {
    padding-left: 0;

    ::v-deep {
      .change {
        &:not(.status):not(.priority) {
          width: 100%;
          flex-wrap: wrap;
        }

        &__text {
          width: 100%;
          text-align: right;
          margin-top: -25px;
        }
      }
    }
  }
}
</style>
